import { Divider } from "antd";

function TermsLegendTitleCard({ title = "مزايا العمل", items }: { title?: string, items?: string[] }) {
    return (
        <div className="terms-legend-title-card">
            <span className="legend-title">
                {title}
            </span>
            <div className="card-terms-list">
                {
                    items?.map((itm, index) => (
                        <div className="item">
                            <div className="item-inner">
                                <div className="marker" />
                                <div style={{ flex: "1" }}>
                                    <span className="text">
                                        {itm}
                                    </span>
                                </div>
                            </div>
                            {
                                index !== items?.length - 1
                                    ? <Divider className="divider" />
                                    : null
                            }
                        </div>
                    ))
                }
            </div>
        </div>
    );
}
export default TermsLegendTitleCard;